/* eslint-disable no-console */
/* eslint-disable no-restricted-properties */
/* eslint-disable complexity */
'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { config, type Currency } from '@/components/forms/stripe-donation-form-config';
interface DonationFormProps {
  readonly currency?: Currency;
}

// eslint-disable-next-line max-lines-per-function
const DonationForm: React.FC<DonationFormProps> = t0 => {
  const $ = _c(79);
  const {
    currency: t1
  } = t0;
  const currency = t1 === undefined ? "USD" : t1;
  const [selectedFrequency, setSelectedFrequency] = useState(config.defaultDonationFrequency);
  const [selectedAmount, setSelectedAmount] = useState(config.defaultDonationAmount);
  const [amountIsCompatibleWithFrequency, setAmountIsCompatibleWithFrequency] = useState(true);
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== amountIsCompatibleWithFrequency || $[1] !== currency || $[2] !== selectedAmount || $[3] !== selectedFrequency) {
    const currencySymbols = {
      GBP: "\xA3",
      USD: "$"
    };
    const getCurrencySymbol = curr => currencySymbols[curr];
    let t15;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = event => {
        const {
          name,
          value
        } = event.target;
        const handlers = {
          "donation-amount": () => setSelectedAmount(value),
          "donation-frequency": () => {
            setSelectedFrequency(value as 'one-time' | 'monthly');
            setAmountIsCompatibleWithFrequency(value !== "monthly");
          }
        };
        const handler = handlers[name];
        if (handler) {
          handler();
        }
      };
      $[17] = t15;
    } else {
      t15 = $[17];
    }
    const handleRadioChange = t15;
    let t16;
    if ($[18] !== currency || $[19] !== selectedAmount || $[20] !== selectedFrequency) {
      t16 = () => {
        const donationLinks = config.paymentEnvironment === "test" ? config.testDonationLinks : config.liveDonationLinks;
        const selectedLink = donationLinks.find(link => link.frequency === selectedFrequency && link.amount === selectedAmount);
        if (!selectedLink && selectedAmount !== "other") {
          console.error("No matching donation link found for the selected amount and frequency.");
          return;
        }
        if (selectedAmount === "other") {
          const otherLink = donationLinks.find(link_0 => link_0.frequency === selectedFrequency && link_0.amount === "other");
          if (otherLink) {
            window.open(otherLink.hrefValuesByCurrency[currency], "_blank");
            return;
          }
        }
        if (selectedLink) {
          window.open(selectedLink.hrefValuesByCurrency[currency], "_blank");
        } else {
          console.error("No matching donation link found.");
        }
      };
      $[18] = currency;
      $[19] = selectedAmount;
      $[20] = selectedFrequency;
      $[21] = t16;
    } else {
      t16 = $[21];
    }
    const handleSubmit = t16;
    t11 = "donation-form";
    if ($[22] !== handleSubmit) {
      t12 = e => {
        e.preventDefault();
        handleSubmit();
      };
      $[22] = handleSubmit;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <legend className="hide">Donate</legend>;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    const t17 = `donation-frequency-option donation-frequency-option-one-time ${selectedFrequency === "one-time" ? "is-checked" : ""}`;
    const t18 = selectedFrequency === "one-time" ? "is-checked" : "";
    const t19 = selectedFrequency === "one-time";
    let t20;
    if ($[25] !== t19) {
      t20 = <input checked={t19} name="donation-frequency" type="radio" value="one-time" onChange={handleRadioChange} />;
      $[25] = t19;
      $[26] = t20;
    } else {
      t20 = $[26];
    }
    let t21;
    if ($[27] !== t18 || $[28] !== t20) {
      t21 = <label className={t18}>{t20}One-time</label>;
      $[27] = t18;
      $[28] = t20;
      $[29] = t21;
    } else {
      t21 = $[29];
    }
    let t22;
    if ($[30] !== t17 || $[31] !== t21) {
      t22 = <li className={t17}>{t21}</li>;
      $[30] = t17;
      $[31] = t21;
      $[32] = t22;
    } else {
      t22 = $[32];
    }
    const t23 = `donation-frequency-option donation-frequency-option-recurring ${selectedFrequency === "monthly" ? "is-checked" : ""}`;
    const t24 = selectedFrequency === "monthly" ? "is-checked" : "";
    const t25 = selectedFrequency === "monthly";
    let t26;
    if ($[33] !== t25) {
      t26 = <input checked={t25} name="donation-frequency" type="radio" value="monthly" onChange={handleRadioChange} />;
      $[33] = t25;
      $[34] = t26;
    } else {
      t26 = $[34];
    }
    let t27;
    if ($[35] !== t24 || $[36] !== t26) {
      t27 = <label className={t24}>{t26}Monthly</label>;
      $[35] = t24;
      $[36] = t26;
      $[37] = t27;
    } else {
      t27 = $[37];
    }
    let t28;
    if ($[38] !== t23 || $[39] !== t27) {
      t28 = <li className={t23}>{t27}</li>;
      $[38] = t23;
      $[39] = t27;
      $[40] = t28;
    } else {
      t28 = $[40];
    }
    let t29;
    if ($[41] !== t22 || $[42] !== t28) {
      t29 = <div className="donation-frequency"><ul className="donation-form-options donation-frequency-options">{t22}{t28}</ul></div>;
      $[41] = t22;
      $[42] = t28;
      $[43] = t29;
    } else {
      t29 = $[43];
    }
    let t30;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t30 = <label className="hide" htmlFor="donation-amount">Donation Amount:</label>;
      $[44] = t30;
    } else {
      t30 = $[44];
    }
    const t31 = selectedAmount === "other";
    let t32;
    if ($[45] !== t31) {
      t32 = <input checked={t31} name="donation-amount" type="radio" value="other" onChange={handleRadioChange} />;
      $[45] = t31;
      $[46] = t32;
    } else {
      t32 = $[46];
    }
    const t33 = <ul className="donation-form-options donation-amount-options">{[25, 100, 200, 500].map(amount => <li className={`donation-amount-option${selectedAmount === amount.toString() ? " is-checked" : ""}`} key={amount}><label className={selectedAmount === amount.toString() ? "is-checked" : ""}><input checked={selectedAmount === amount.toString()} name="donation-amount" type="radio" value={amount.toString()} onChange={handleRadioChange} />{getCurrencySymbol(currency)}{amount}</label></li>)}<li className={`donation-amount-option donation-amount-option-other${selectedAmount === "other" ? " is-checked" : ""}`} data-donation-amount-is-compatible-with-donation-frequency={amountIsCompatibleWithFrequency}><label className={selectedAmount === "other" ? "is-checked" : ""}>{t32}{getCurrencySymbol(currency)}Other Amount</label></li></ul>;
    let t34;
    if ($[47] !== t33) {
      t34 = <div className="donation-amounts">{t30}{t33}</div>;
      $[47] = t33;
      $[48] = t34;
    } else {
      t34 = $[48];
    }
    if ($[49] !== t29 || $[50] !== t34) {
      t14 = <div className="donation-frequency-and-donation-amounts">{t29}{t34}</div>;
      $[49] = t29;
      $[50] = t34;
      $[51] = t14;
    } else {
      t14 = $[51];
    }
    t9 = "donation-form-submit-and-confirmation-display";
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="donation-form-submit-and-confirmation-display-cell"><button className="enhance-press" type="submit">Donate Now</button></div>;
      $[52] = t10;
    } else {
      t10 = $[52];
    }
    t8 = "donation-form-submit-and-confirmation-display-cell";
    t4 = "donation-frequency-and-amount-confirmation";
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <dt>Donation Frequency:</dt>;
      $[53] = t5;
    } else {
      t5 = $[53];
    }
    const t35 = selectedFrequency === "one-time" ? "One-time donation" : "Monthly donation";
    if ($[54] !== t35) {
      t6 = <dd className="donation-frequency">{t35}</dd>;
      $[54] = t35;
      $[55] = t6;
    } else {
      t6 = $[55];
    }
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <dt>Donation Amount:</dt>;
      $[56] = t7;
    } else {
      t7 = $[56];
    }
    t2 = "donation-amount";
    t3 = selectedFrequency === "monthly" && selectedAmount === "other" ? "Please select an amount above" : selectedAmount === "other" ? `${getCurrencySymbol(currency)}Other` : `${getCurrencySymbol(currency)}${selectedAmount}`;
    $[0] = amountIsCompatibleWithFrequency;
    $[1] = currency;
    $[2] = selectedAmount;
    $[3] = selectedFrequency;
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
    $[7] = t13;
    $[8] = t14;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t10 = $[4];
    t11 = $[5];
    t12 = $[6];
    t13 = $[7];
    t14 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t15;
  if ($[57] !== t2 || $[58] !== t3) {
    t15 = <dd className={t2}>{t3}</dd>;
    $[57] = t2;
    $[58] = t3;
    $[59] = t15;
  } else {
    t15 = $[59];
  }
  let t16;
  if ($[60] !== t15 || $[61] !== t4 || $[62] !== t5 || $[63] !== t6 || $[64] !== t7) {
    t16 = <dl className={t4}>{t5}{t6}{t7}{t15}</dl>;
    $[60] = t15;
    $[61] = t4;
    $[62] = t5;
    $[63] = t6;
    $[64] = t7;
    $[65] = t16;
  } else {
    t16 = $[65];
  }
  let t17;
  if ($[66] !== t16 || $[67] !== t8) {
    t17 = <div className={t8}>{t16}</div>;
    $[66] = t16;
    $[67] = t8;
    $[68] = t17;
  } else {
    t17 = $[68];
  }
  let t18;
  if ($[69] !== t10 || $[70] !== t17 || $[71] !== t9) {
    t18 = <div className={t9}>{t10}{t17}</div>;
    $[69] = t10;
    $[70] = t17;
    $[71] = t9;
    $[72] = t18;
  } else {
    t18 = $[72];
  }
  let t19;
  if ($[73] !== t11 || $[74] !== t12 || $[75] !== t13 || $[76] !== t14 || $[77] !== t18) {
    t19 = <><form className={t11} onSubmit={t12}>{t13}{t14}{t18}</form></>;
    $[73] = t11;
    $[74] = t12;
    $[75] = t13;
    $[76] = t14;
    $[77] = t18;
    $[78] = t19;
  } else {
    t19 = $[78];
  }
  return t19;
};
export default DonationForm;